module.exports = __webpack_public_path__ + "media/images/proof_links/colored/vk-b03024c4d635b0a304e483e1d9fa34d8.svg";